import { Container } from "../../../../styledComponents/Container/styled";
import { HeaderCustom } from "../../../../../../styled";


const WebPosition = () => (
    <Container>
    <HeaderCustom>Website Positioning (SEO), Social Media growing</HeaderCustom>
  </Container>
);

export default WebPosition;